

export interface ProviderViewModel {
    provider: string
}

export interface SSOViewModel {
    [key: string]: ProviderViewModel
}

export interface AppSettingViewModel{
    sso: SSOViewModel,
    notAllowedDomains: string[]
}